import { render, staticRenderFns } from "./buyerBehaviorHistoryDetail.vue?vue&type=template&id=4c2f302b&scoped=true&"
import script from "./buyerBehaviorHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./buyerBehaviorHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f302b",
  null
  
)

export default component.exports